// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_wrap__9B-OI {
  min-height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #f5f6f7;
  box-sizing: border-box;
}

.style_card__J-0S6 {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  padding: 2rem 1.5rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.style_icon__3JK4t {
  font-size: 2.75rem;
  color: #e0a800;
  line-height: 1;
}

.style_title__s8\\+jj {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.style_text__yOBie {
  margin: 0;
  font-size: 0.95rem;
  color: #6b7280;
  line-height: 1.4;
}

.style_actions__PcXM7 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  margin-top: 0.75rem;
}
.style_actions__PcXM7 > * {
  width: 100%;
}

.style_detalle__rqH8Z {
  margin-top: 1rem;
  width: 100%;
  text-align: left;
}
.style_detalle__rqH8Z summary {
  cursor: pointer;
  font-size: 0.8rem;
  color: #9ca3af;
}
.style_detalle__rqH8Z pre {
  margin-top: 0.5rem;
  max-height: 220px;
  overflow: auto;
  background: #111827;
  color: #f3f4f6;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 0.72rem;
  white-space: pre-wrap;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/feedback/ErrorBoundary/style.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACI;EACI,WAAA;AACR;;AAGA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;AAEI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAGI;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AADR","sourcesContent":[".wrap {\n    min-height: 100dvh;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1.5rem;\n    background: #f5f6f7;\n    box-sizing: border-box;\n}\n\n.card {\n    width: 100%;\n    max-width: 420px;\n    background: #fff;\n    border-radius: 16px;\n    padding: 2rem 1.5rem;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.icon {\n    font-size: 2.75rem;\n    color: #e0a800;\n    line-height: 1;\n}\n\n.title {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1f2937;\n}\n\n.text {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #6b7280;\n    line-height: 1.4;\n}\n\n.actions {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n    margin-top: 0.75rem;\n\n    > * {\n        width: 100%;\n    }\n}\n\n.detalle {\n    margin-top: 1rem;\n    width: 100%;\n    text-align: left;\n\n    summary {\n        cursor: pointer;\n        font-size: 0.8rem;\n        color: #9ca3af;\n    }\n\n    pre {\n        margin-top: 0.5rem;\n        max-height: 220px;\n        overflow: auto;\n        background: #111827;\n        color: #f3f4f6;\n        padding: 0.75rem;\n        border-radius: 8px;\n        font-size: 0.72rem;\n        white-space: pre-wrap;\n        word-break: break-word;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `style_wrap__9B-OI`,
	"card": `style_card__J-0S6`,
	"icon": `style_icon__3JK4t`,
	"title": `style_title__s8+jj`,
	"text": `style_text__yOBie`,
	"actions": `style_actions__PcXM7`,
	"detalle": `style_detalle__rqH8Z`
};
export default ___CSS_LOADER_EXPORT___;
